import {
  uploadMediaEndPoint,
  downloadMediaEndPoint,
  addSiteToGroupEndPoint,
  removeSiteToGroupEndPoint,
  deleteMediaEndPoint,
} from "../configuration";
import axios from "axios";
import { getRandomUUID } from "../../src/Token";
import axiosInstance from "../global/axiosInterceptor";
import { handleApiError } from "../global/utility/Utils";

export const imageUploadMedia = async (image, activeSession) => {
  try {
    const response = await axiosInstance.post(uploadMediaEndPoint(), image, {
      isImage: true,
    });
    return typeof response.data === "string"
      ? JSON.parse(response.data)
      : response.data;
  } catch (error) {
    console.error(
      "Error uploading file: ",
      error.response ? error.response.data : error.message
    );

    return;
  }
};

export const deleteMedia = async (imageId, activeSession) => {
  const url = deleteMediaEndPoint();
  try {
    const deleteResponse = await axiosInstance.delete(url, {
      data: {
        accountname: activeSession.accountId,
        resourceidentifier: {
          id: imageId,
        },
      },
    });
    return deleteResponse;
  } catch (error) {
    console.error(
      "Error deleting image: ",
      error.response ? error.response.data : error.message
    );
    const errorMessage = error?.response?.data?.error_description;
    handleApiError(
      "warning",
      errorMessage ? errorMessage : "Failed to delete image, please try again."
    );
    return [];
  }
};

export const ImageDownloadMedia = async (
  imageId,
  activeSession,
  streamId = "",
  mediaSource = ""
) => {
  try {
    const config = { responseType: "arraybuffer" };
    
    // valid mediaSource values "evidence", "snapshot"
    const response = await axiosInstance.post(
      downloadMediaEndPoint(),
      {
        accountname: activeSession.accountId,
        resourceidentifier: {
          id: imageId,
        },
        ...(mediaSource && { mediaSource }),
      },
      config
    );
    const blob = new Blob([response.data], { type: "image/png" });
    const url = URL.createObjectURL(blob);
    if (streamId) {
      blobUrltobase64(url).then((base64) => {
        const floorImages = JSON.parse(sessionStorage.getItem("pairedImages"));
        const Image =
          (floorImages &&
            floorImages.filter((obj) => obj.snapshotId !== streamId)) ||
          [];
        Image.push({ snapshotId: streamId, base64: base64 });
        // sessionStorage.setItem("pairedImages", JSON.stringify(Image));
      });
    }
    return url;
  } catch (error) {
    console.error("Error downloading image:", error);
    console.error(error.error_description ? error.error_description : error);
    throw error;
  }
};

export const blobUrltobase64 = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((response) => {
        if (!response?.ok) {
          throw new Error(`Http error! status: ${response?.status}`);
        }
        return response?.blob();
      })
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      })
      .catch(reject);
  });
};
export const base64ToBlobUrl = (base64) => {
  const baseData = base64.split(",")[1];
  const bytechar = window.atob(baseData);
  const bytenum = Array.from(bytechar).map((char) => char.charCodeAt(0)); //new Array(bytechar.length).map((_, i)=>bytechar.charCodeAt(i));
  const byteArr = new Uint8Array(bytenum);

  const blob = new Blob([byteArr], { type: "image/png" });
  return URL.createObjectURL(blob);
};
export const usersAssociatingToSite = async (
  userId,
  siteTagIds,
  activeSession
) => {
  try {
    const url = addSiteToGroupEndPoint();
    const accountName = sessionStorage?.getItem("accountId");

    const href = `#/users/id/${userId}`;

    const payload = {
      $hrefs: [href],
      accountname: accountName,
      resourceidentifier: {
        id: siteTagIds[0],
      },
    };

    const response = await axiosInstance.post(url, payload);

    return response.data;
  } catch (error) {
    console.error(
      "Error associating user to site:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const removeUsersFromSite = async (
  userId,
  siteTagIds,
  activeSession
) => {
  try {
    const url = removeSiteToGroupEndPoint();
    const vzM2mToken = getRandomUUID(activeSession);
    const accountName = sessionStorage.getItem("accountId");

    const href = `#/users/id/${userId}`;

    const payload = {
      $hrefs: [href],
      accountname: accountName,
      resourceidentifier: {
        id: siteTagIds[0],
      },
    };

    const response = await axiosInstance.post(url, payload);

    return response.data;
  } catch (error) {
    console.error(
      "Error removing user from site:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
